<template>
    <div class="wrap-header">
        <div class="header" :class="{active:index==1}">
            <div class="logo">
                <router-link to="/index">
                    <img src="../static/images/logo.png" v-show="!isShow"/>
                </router-link>
            </div>
            <div class="n-menu">
                <span class="nav-link" @click="change" :class="{'active':isShow}"></span>
            </div>
        </div>
        <div class="slide-menu" :class="{'active':isShow}" @touchmove.prevent>
            <ul class="menu-list animation">
                <li class="m-nav-item" :class="{'active':item.show}" v-for="(item,index) in menuNav" :key="index" @click="changeli(index,item)">
                    <router-link :to="item.path || ''"  class="m-nav-link" :class="{'arrow-active':item.list.length}">{{item.title}}</router-link>
                    <ol class="nav-dropDown-list" v-if="item.list.length">
                        <li class="nav-dropDown-item" v-for="(i,two) in item.list" :key="two">
                            <router-link :to="i.path" class="nav-dropDown-link">
                                {{i.name}}
                            </router-link>
                        </li>
                    </ol>
                </li>
            </ul>
            <div class="icon-list">
                <a href="https://m.facebook.com/Trout-Partners-408944576586177/?_rdr" class="item"><img src="../static/images/facebook_icon.png"></a>
                <a href="http://twitter.com/TroutPartners" class="item"><img src="../static/images/twitter_icon.png"></a>
                <a href="https://www.linkedin.com/company/troutandpartners/" class="item"><img src="../static/images/linkedIn_icon.png"></a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            index:{
                default:0,
                type:Number
            }
        },
        data(){
            return{
                isShow:false,
                menuNav:[
                    {
                        title:'ABOUT',
                        list:[
                            {
                                path:'/about/index',
                                name:'About Us'
                            },
                            {
                                path:'/about/teams',
                                name:'Our Teams'
                            },
                            {
                                path:'/about/contact',
                                name:'Contact us'
                            }
                        ],
                        show:0,
                        path:''
                    },
                    {
                        title:'POSITIONING',
                        list:[
                            {
                                path:'/positioning/introduce',
                                name:'Jack Trout'
                            },
                            {
                                path:'/positioning/concept',
                                name:'Concept'
                            },
                            {
                                path:'/positioning/history',
                                name:'History'
                            }
                        ],
                        show:0,
                        path:''
                    },
                    {
                        title:'SERVICE',
                        list:[
                            {
                                path:'/service/consulting',
                                name:'Consulting'
                            },
                            {
                                path:'/service/clients',
                                name:'Clients'
                            }
                        ],
                        show:0,
                        path:''
                    },
                    {
                        title:'INSIGHTS',
                        list:[],
                        path:'/insights/index',
                        show:0
                    },
                    {
                        title:'NEWS',
                        list:[],
                        path:'/news/index',
                        show:0
                    },
                ]
            }
        },
        methods:{
            change(){
                this.isShow = !this.isShow
            },
            changeli(index, item) {
                // 先循环数据中的show将其全部置为false,此时模板里的v-if判断生效关闭全部二级菜单,并移除样式
                this.menuNav.forEach(i => {
                    // 判断如果数据中的headerData[i]的show属性不等于当前数据的show属性那么headerData[i]等于false
                    if (i.show !== this.menuNav[index].show) {
                        i.show = false;
                    };
                });
                // 取反(true或false)
                item.show = !item.show;
            },
        }
    }
</script>

<style lang="less" rel="stylesheet/less">
    .header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: absolute;
        top: 0;
        width: 100%;
        left: 0;
        padding: .4rem;
        box-sizing: border-box;
        z-index: 11;
        &.active{
            position: fixed;
            top: 0;
            width: 100%;
            left: 0;
        }
        .logo{
            width: 2.5rem;
            height: .28rem;
            a {
                display: block;
                width: 100%;
                height: 100%;
            }
            img{
                width: 100%;
            }
        }
        .n-menu{
            position: relative;
            width: .44rem;
            height: .44rem;
            z-index: 99;
            .nav-link{
                background: url(../assets/imgs/menuHover.png) no-repeat center;
                background-size: 100%;
                display: inline-block;
                width: .44rem;
                height: .44rem;
                &.active {
                    background: url(../assets/imgs/closeHover.png) no-repeat center;
                    background-size: 100%;
                }
            }
        }
    }
    //侧边菜单栏
    .slide-menu{
        position: fixed;
        top: 0;
        right: -100%;
        width: 100%;
        bottom: 0;
        background: #eeeeee;
        z-index:9;
        transition: right .3s;

        &.active{
            right: 0;
        }
        .menu-list {
            width: 100%;
            height: 100%;
            padding-top: 25%;
            box-sizing: border-box;
            .m-nav-link{
                color: #595757;
                font-size: .48rem;
                font-weight: bold;
                position: relative;
                &.arrow-active{
                    &:after{
                        content: '';
                        display: inline-block;
                        width: .17rem;
                        height: .09rem;
                        background: url("../assets/imgs/arrow_down.png") no-repeat center center;
                        background-size: cover;
                        vertical-align: middle;
                        margin-left: .2rem;
                    }
                }
            }
            .m-nav-item {
                position: relative;
                display: block;
                text-align: center;
                line-height: 1.3rem;
                font-weight: bold;
                transition: all 1s;
                &.active{
                    .nav-dropDown-list{
                        .nav-dropDown-item{
                            height: .8rem;
                            line-height: .8rem;
                            animation: heightBar 1s;
                        }
                    }
                }
            }
            .nav-dropDown-list{
                z-index: 8;
                opacity: 0.6;
                position: relative;
                overflow: hidden;
                transition: all 1s;

                .nav-dropDown-item{
                    height: 0;
                }
            }
            .nav-dropDown-link {
                line-height: .6rem;
                font-size: .28rem;
                color: #666;
            }
        }
        .icon-list{
            position: absolute;
            width: 100%;
            left: 0;
            text-align: center;
            bottom: .5rem;
            a{
                width: .73rem;
                height: .73rem;
                border-radius: 100%;
                background: #f00;
                display: inline-block;
                margin-left: .7rem;
                vertical-align: top;
                img{
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    vertical-align: top;
                }
                &:first-child{
                    margin-left: 0;
                }
            }
        }
    }
    @-webkit-keyframes heightBar{
        0%{height:0;}
        100%{height:.8rem;}
    }
</style>
